'use client';

import Input from 'src/components/primitives/Input/Input';
import { useEffect, useRef, useState } from 'react';
import PopoverWrapper, { FloatingPopoverProps } from '../PopoverWrapper';
import Button from 'src/components/primitives/Button/Button';

interface Props extends FloatingPopoverProps {
	initialValue: number;
	maxValue: number;
	onClose: (newValue: number) => void;
}

const PaginationInputPopup = (props: Props) => {
	const [currentVal, setCurrentVal] = useState('');

	const handleValueChange = (value: string) => {
		// Only allow integers (positive numbers without decimal points)
		if (value === '' || /^\d+$/.test(value)) {
			setCurrentVal(value);
		}
	};

	const handleExitClose = () => {
		props.onClose(props.initialValue);
	};

	const handleSaveClose = () => {
		let valueToTry = parseInt(currentVal ? currentVal : '0');

		valueToTry = Math.min(valueToTry, props.maxValue);
		valueToTry = Math.max(valueToTry, 0);

		props.onClose(valueToTry);
	};

	const inputRef = useRef<HTMLInputElement>(null);

	useEffect(() => {
		inputRef.current?.focus();
	}, [inputRef.current]);

	return (
		<PopoverWrapper
			ref={props.setFloating}
			style={props.floatingStyles}
			{...props.getFloatingProps()}
		>
			<div className="flex w-34 flex-col gap-y-sm p-md">
				<span className="typo-label-xs whitespace-nowrap text-text-secondary">
					Jump to page
				</span>

				<div className="flex items-center gap-x-xs">
					<Input
						labelVariant="none"
						type="number"
						placeholder="0"
						value={currentVal}
						onChange={handleValueChange}
						onEnter={handleSaveClose}
						onEscape={handleExitClose}
						ref={inputRef}
					/>

					<Button size="md" variant="secondary" onClick={handleSaveClose}>
						Go
					</Button>
				</div>
			</div>
		</PopoverWrapper>
	);
};

export default PaginationInputPopup;
